import styled from "@emotion/styled";
import React from "react";
import { SingleCheckBox, TextInput } from "../../form";
import { Checkbox } from "antd";
import { Controller } from "react-hook-form";

const CheckboxWrapper = styled.div(() => ({
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
}));

const CautionWrapper = styled.div(() => ({
  padding: "2rem",
  fontSize: "1.2rem",
  backgroundColor: "#f5f5f5",
  borderRadius: "1rem",

  b: {
    display: "block",
    marginBottom: "0.4rem",
    fontWeight: "bold",
  },
}));

const CampaignCheckBoxGroupTwo = ({ control, watch }) => {
  return (
    <CheckboxWrapper>
      <section>
        <label>AI 활용 여부 (AI를 활용한 영상 출품 가능)</label>

        <div>
          <Controller
            name="is_ai"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  예
                </Checkbox>
                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  아니오
                </Checkbox>
              </>
            )}
          />
        </div>

        {watch("is_ai") === true && (
          <div>
            <div style={{ marginTop: "1rem" }}>
              <TextInput
                maxLength={20}
                control={control}
                name="ai_tool"
                label="활용한 AI 툴 정보 입력"
                placeholder="활용한 AI 툴 정보를 모두 입력해주세요 / 예) 제미나이"
              />
            </div>
          </div>
        )}
      </section>

      <section>
        <label>타 공모전 출품 여부</label>

        <p style={{ color: "red" }}>
          ※타 공모전과 중복 응모는 가능하나, 중복 수상은 불가합니다.
        </p>

        <div>
          <Controller
            name="is_submit_other_contest"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  예
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  아니오
                </Checkbox>
              </>
            )}
          />
        </div>

        {watch("is_submit_other_contest") === true && (
          <div style={{ marginTop: "1rem" }}>
            <TextInput
              control={control}
              name="other_contest_name"
              label="출품한 타 공모전 명"
              maxLength={300}
              placeholder="중복 출품한 공모전 명 모두 입력 필수"
              customMessage={
                <p style={{ color: "red" }}>
                  타 공모전에 중복 출품한 경우, 출품한 공모전 명을 반드시 전부
                  남겨주시기 바랍니다.
                </p>
              }
            />
          </div>
        )}
      </section>

      <section>
        <label>
          타 공모전과 중복 입상 확인 시, 수상이 취소되고 상금이 환수될 수 있음을
          동의합니다.
        </label>

        <p style={{ color: "red" }}>※비동의 시, 심사 대상에서 제외됩니다.</p>

        <div>
          <Controller
            name="is_agree_other_contest"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  동의
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  비동의
                </Checkbox>
              </>
            )}
          />
        </div>
      </section>

      <section>
        <label>
          지적재산권을 침해한 작품, 제3자에 대한 초상권 및 타인의 명예를 훼손한
          작품, 타인의 저작물 및 명의를 도용한 경우 수상이 취소되고 상금이
          환수될 수 있음을 동의합니다.
        </label>

        <p style={{ color: "red" }}>※비동의 시, 심사 대상에서 제외됩니다.</p>

        <div>
          <Controller
            name="is_agree_copyright"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  동의
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  비동의
                </Checkbox>
              </>
            )}
          />
        </div>
      </section>

      <section>
        <SingleCheckBox
          name="privacy_policy"
          control={control}
          label="개인정보 수집 및 이용 동의 (필수)"
        />
        <p style={{ color: "red" }}>※비동의 시, 참가에 제한됩니다.</p>

        <CautionWrapper>
          <b>
            사단법인 세이브더얼스의 개인정보 수집 이용 목적은 다음과 같습니다.{" "}
          </b>

          <ul>
            <li>1. 공모전 운영 안내</li>
            <li>2. 이름, 연락처, 이메일</li>
            <li>3. 보유 이용 기간 : 수집 일로부터 1년까지</li>
          </ul>

          <p>
            귀하는 위와 같이 개인정보를 수집, 이용하는 데 동의를 거부할 권리가
            있습니다. 필수 수집항목에 대한 동의를 거절하시는 경우 참가에 제한될
            수 있습니다.
          </p>
        </CautionWrapper>
      </section>

      <CautionWrapper>
        <b>[유 의 사 항]</b>

        <p>
          - 사단법인 세이브더얼스 공식 홈페이지 회원 가입과 SNS 채널(유튜브 및
          인스타그램) 구독을 모두 완료한 사람에 한하여 참여 가능합니다.
        </p>
        <p>
          <small>
            (홈페이지 회원 가입 + SNS 채널 구독, 접수 시 계정 정보 입력 필수)
          </small>
        </p>

        <div style={{ marginBottom: "1rem" }}>
          <p>
            <span> ◎ 홈페이지 : </span>

            <a
              href="https://www.savetheearth.or.kr/"
              target="_blank"
              rel="noreferrer"
            >
              https://www.savetheearth.or.kr/
            </a>
          </p>
          <p>
            <span>◎ 유 튜 브 : </span>

            <a
              href="https://www.youtube.com/@save_the_earth_tv"
              target="_blank"
              rel="noreferrer"
            >
              www.youtube.com/@save_the_earth_tv
            </a>
          </p>
          <p>
            <span>◎ 인스타그램 : </span>
            <a
              href="https://www.instagram.com/2023.savetheearth"
              target="_blank"
              rel="noreferrer"
            >
              https://www.instagram.com/2023.savetheearth
            </a>
          </p>
        </div>

        <p>
          - 작품을 게시한 SNS 계정은 반드시 &apos;전체 공개&apos; 상태여야 하며,
          &apos;비공개&apos; 계정은 심사 대상에서 제외됩니다.
        </p>
        <p>- 수상 종류 및 상금은 심사 결과에 따라 변경될 수 있습니다.</p>
        <p>- 상금은 관련 세법에 따라 제세 공과금을 공제한 후 지급됩니다.</p>
        <p>
          - 수상작은 세이브더얼스 홈페이지, SNS, 유튜브 등에서 홍보 목적으로
          활용될 수 있으며, 이에 대한 지적재산권은 상금으로 대체됩니다.
        </p>
        <p>
          - 수상작은 환경 홍보 목적에 한하여 필요시 수정 및 변형되어 활용될 수
          있습니다.
        </p>
        <p>
          - 작품과 관련된 초상권, 저작권 등 모든 법적 분쟁에 대한 책임은
          응모자에게 있습니다.
        </p>
        <p>
          - 타 공모전과 중복 출품 가능하나, 타 공모전 수상 시 중복 수상은
          불가합니다.
        </p>
        <p>
          - 여러 작품 추가 출품 가능하나, 단 한 편의 작품만 수상 가능합니다.
        </p>
        <p>
          - 수상작 발표 이후 이의 제기 기간 운영, 외부 제보 접수 가능합니다.
        </p>

        <p>
          - 다음에 해당하는 경우 수상이 취소되며, 지급된 상금은 환수될 수
          있습니다.
        </p>

        <p style={{ marginTop: "1rem" }}>
          ① 타 공모전 수상작 또는 지적재산권 침해 작품
          <br />
          ② 제3자의 초상권 또는 명예를 침해한 작품
          <br />③ 타인의 저작물 또는 명의를 도용한 작품
        </p>
      </CautionWrapper>
    </CheckboxWrapper>
  );
};

export default CampaignCheckBoxGroupTwo;
